import Image from "next/image";
import { useAppDispatch } from "redux-share/hooks";
import { setAutoPlayPopover, setRecommendListPopover } from "redux-share/slices/popoversSlice";
import { findFirstVideoInRecommendationList } from "redux-share";

const AutoPlayListIcon = () => {

    const dispatch = useAppDispatch();
    const recommendationVideo = findFirstVideoInRecommendationList();

    const handleClickIcon = () => {
        dispatch(setAutoPlayPopover(true));
        dispatch(setRecommendListPopover(true));
    }

    return (        
        <div className="pl-absolute pl-bottom-[150%] pl-right-6 pl-flex pl-items-center pl-gap-1" onClick={handleClickIcon}>
            <div className="pl-relative pl-w-[105px] pl-h-[51px] pl-rounded-[8px]">
                <div className="pl-w-full pl-flex pl-justify-center">
                    <div className="pl-w-[80%] pl-h-full pl-absolute pl-bottom-[20%] pl-flex pl-justify-center pl-opacity-70">
                        <Image src={recommendationVideo.banner} width={105} height={51} className="pl-rounded-[8px]" />
                    </div>
                </div>
                <Image src={recommendationVideo.banner} width={105} height={51} className="pl-rounded-[8px]" />
            </div>
            <p className="pl-w-[125px] pl-text-white">ویدیوهای بیشتر کلیک کنید</p>
        </div>
    )
}

export default AutoPlayListIcon